import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../theme/index.css' //自定义
import './base.less'
import './main.less'
import http from './request.js' 
import md5 from 'js-md5';

Vue.use(ElementUI);
Vue.config.productionTip = false

Vue.prototype.http = http
Vue.prototype.domain = http.domain
Vue.prototype.$md5 = md5

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
